import { useRouter } from 'next/router';
import Link, { LinkProps } from 'next/link';
import React, { useMemo } from 'react';
import { useGradebookDispatch } from '@components/context/GradebookContext';

export const ActiveLink = ({
    children,
    activeStyle = 'bg-teal-100',
    isFuzzyMatch,
    ...props
}: LinkProps & {
    children: React.ReactNode | Function;
    activeStyle?: string;
    isFuzzyMatch?: boolean;
}) => {
    const { asPath, pathname, ...rest } = useRouter();
    const isActive =
        asPath === props.href ||
        asPath === props.as ||
        props.href === pathname ||
        (isFuzzyMatch && asPath?.startsWith((props?.href as string) || ''));

    const classStyle = useMemo(() => {
        return isActive ? 'text-passport' : '';
    }, [isActive]);

    if (typeof children === 'function') {
        return (
            <Link {...props} passHref>
                <a className={classStyle}>
                    <div className={`relative w-full rounded-md`}>{children({ isActive })}</div>
                </a>
            </Link>
        );
    }

    return (
        <Link {...props} passHref>
            <a className={classStyle}>
                <div
                    className={`active-link relative w-full hover:bg-gray-100 rounded-md ${
                        isActive ? activeStyle : ''
                    }`}>
                    {children}
                </div>
            </a>
        </Link>
    );
};

export const SideBarLink = ({
    children,
    activeStyle = 'bg-teal-100',
    nextPathNames = [],
    text,
    ...props
}: LinkProps & {
    children: React.ReactNode | Function;
    activeStyle?: string;
    nextPathNames?: string[];
    text?: string;
}) => {
    const { asPath, pathname } = useRouter();
    const isActive = useMemo(() => {
        if (asPath === props.href || asPath === props.as || props.href === pathname) {
            return true;
        }
        if (nextPathNames?.length > 0) {
            return nextPathNames.includes(pathname);
        }
        return false;
    }, [asPath, pathname, nextPathNames]);

    const { resetGradebookData } = useGradebookDispatch();

    if (typeof children === 'function') {
        return (
            <Link {...props} passHref>
                <a
                    className={` ${isActive ? 'text-passport' : ''}`}
                    onClick={() => {
                        if (text === 'Gradebook') resetGradebookData(true);
                    }}>
                    <div className={`relative w-full rounded-md`}>{children({ isActive })}</div>
                </a>
            </Link>
        );
    }
    return (
        <Link {...props} passHref>
            <a className={` ${isActive ? 'text-passport' : ''}`}>
                <div
                    className={`sidebar-link relative w-full hover:bg-gray-100 rounded-md ${
                        isActive ? activeStyle : ''
                    }`}>
                    {children}
                </div>
            </a>
        </Link>
    );
};
